// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import Argon from "@/plugins/argon-kit";
import BootstrapVue from "bootstrap-vue"
import VueAnalytics from "vue-analytics"
import VueHead from 'vue-head'
import store from '@/store'
import vuescroll from 'vue-scroll'
import vueDirectiveTooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(Argon);
Vue.use(VueHead)
Vue.use(vuescroll)
Vue.use(vueDirectiveTooltip)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.use(VueAnalytics, {
  id: require('../package.json').vueanalytics,
  router
});



// WEBPACK FOOTER //
// ./src/main.js